var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgList = function SvgList(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 19,
    viewBox: "0 0 12.4 12.4",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.167 12.333h-8A2.173 2.173 0 0 1 0 10.167v-8A2.173 2.173 0 0 1 2.167 0h8a2.173 2.173 0 0 1 2.166 2.167v8a2.173 2.173 0 0 1-2.166 2.166M2.167 1A1.173 1.173 0 0 0 1 2.167v8a1.173 1.173 0 0 0 1.167 1.166h8a1.173 1.173 0 0 0 1.166-1.166v-8A1.173 1.173 0 0 0 10.167 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6.167 3.5H9.5M2.834 3.5H3.5M6.167 6.167H9.5M2.834 6.167H3.5M6.167 8.833H9.5M2.834 8.833H3.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgList);
export default ForwardRef;